import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import { presetStateSelector } from "../utils/state.js";
const initialState = {};
export const setSetting = createAction("settings/setSetting");
function updateSettings(state, payload) {
    if ("center" in payload) {
        state.center = payload.center;
    }
    if ("zoom" in payload) {
        state.zoom = payload.zoom;
    }
    if ("bearing" in payload) {
        state.bearing = payload.bearing;
    }
    if ("pitch" in payload) {
        state.pitch = payload.pitch;
    }
    if ("roll" in payload) {
        state.roll = payload.roll;
    }
    if ("light" in payload) {
        state.light = payload.light;
    }
    if ("sky" in payload) {
        state.sky = payload.sky;
    }
    if ("projection" in payload) {
        state.projection = payload.projection;
    }
    if ("terrain" in payload) {
        state.terrain = payload.terrain;
    }
}
export const settingsReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setSetting, (state, { payload }) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        updateSettings(state, payload);
    });
});
export const getSettingsState = createSelector([presetStateSelector], present => present.settings);
